// global
import React, { Component, memo } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
// local
// consts
import { GROUPS } from 'app/config/consts';
// api
import * as Profession from 'app/api/profession';
// views
import NestedDropdown from 'app/components/commons/dropdown/nested/NestedDropdown';
import CustomDropdown from 'app/components/commons/dropdown/CustomDropdown';
import ErrorLabel from 'app/components/commons/label/ErrorLabel';
// libs
import { sortString } from 'app/utils';
// stylesheet
/* import styles from './dropdown.module.scss'; */

class ProfessionDropdown extends Component {
  state = {
    loading: true,
    options: []
  };

  componentDidMount() {
    Profession.listProfessions()
      .then(this.onLoadProfessionSuccess)
      .catch(this.onLoadProfessionFail);
    this._isMounted = true;
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  onLoadProfessionSuccess = professions => {
    const { auth } = this.props;
    const { account } = auth;

    let allProfessions = professions.filter(profession => profession.status === 1);

    allProfessions = professions.map(profession => {
      if (account.groupId === GROUPS.SALVUS_ADMIN) {
        return {
          text: `${profession.name} (${profession.client.name})`,
          value: parseInt(profession.id)
        };
      }

      return { text: profession.name, value: parseInt(profession.id) };
    });

    allProfessions.sort((a, b) => sortString(a.text, b.text));

    const options = [{ text: '', value: null }, ...allProfessions];

    if (this._isMounted) {
      this.setState({
        loading: false,
        options
      });
    }
  };

  onLoadProfessionFail = () => {
    if (this._isMounted) {
      this.setState({
        loading: false,
        options: []
      });
    }
  };

  render() {
    const { options, loading } = this.state;

    const { value, onChange, error } = this.props;
    const { isForm, width, required, disabled } = this.props;
    const { showLabel, label, placeholder, styleName, /* className */ nested } = this.props;

    if (nested) {
      return (
        <NestedDropdown
          options={options}
          name='Profissional'
          onOptionSelection={this.props.onOptionSelection}
        />
      );
    }

    return (
      <CustomDropdown
        loading={loading}
        options={options}
        value={value}
        onChange={onChange}
        error={error}
        isForm={isForm}
        width={width}
        required={required}
        disabled={disabled}
        placeholder={placeholder}
        styleName={styleName}
        // className={styles[`${className}`]}
        label={showLabel && <ErrorLabel label={label} error={error} />}
        selection
      />
    );
  }
}

ProfessionDropdown.defaultProps = {
  isForm: true,
  showLabel: true,
  label: 'Profissional',
  placeholder: 'Profissional',
  className: 'styleModal'
};

ProfessionDropdown.propTypes = {
  onOptionSelection: PropTypes.func,
  nested: PropTypes.bool,
  auth: PropTypes.object,
  value: PropTypes.any,
  onChange: PropTypes.func,
  error: PropTypes.bool,
  isForm: PropTypes.bool,
  width: PropTypes.number,
  required: PropTypes.bool,
  disabled: PropTypes.bool,
  showLabel: PropTypes.bool,
  label: PropTypes.string,
  placeholder: PropTypes.string,
  // className: PropTypes.oneOf(['styleModal', 'styleReport']),
  styleName: PropTypes.string
};

const mapStateToProps = state => ({
  auth: state.auth
});

export default connect(mapStateToProps)(memo(ProfessionDropdown));
